require('./scaDisclaimerModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @components
const OKModal = require('components/commons/OKModal/OKModal');

// @ assets
const iconError = require('assets/images/icon-error.svg');

const ScaDisclaimerModal = ({ onPrimaryButtonClick, visible, onCloseCallback, phone, getTitleAndDescription, showPN }) => {
    const message = (!!getTitleAndDescription && showPN) ? getTitleAndDescription('scaDisclaimer-pushNotifictaionMessage', 'scaDisclaimer-genericMessage', 'scaDisclaimer-message') : 'scaDisclaimer-message';

    return (
        <div className="sca-modal-disclaimer">
            <OKModal
                content={(
                    <React.Fragment>
                        <div className="sca-modal-disclaimer__icon-img">
                            <img src={iconError} className="sca-modal-disclaimer__icon-img--icon" />
                        </div>
                        <div className="sca-modal-disclaimer__primary-text">
                            <FormattedText value='scaDisclaimer-title' />
                        </div>
                        <p className="sca-modal-disclaimer__secondary-text">
                            <FormattedText value={message} injectedStrings={[phone]} />
                        </p>
                    </React.Fragment>
                )}
                footerType="action"
                isOpen={visible}
                onCloseCallback={onCloseCallback}
                onPrimaryButtonClick={onPrimaryButtonClick}
                onSecondaryButtonClick={onCloseCallback}
                primaryButtonText="scaDisclaimer-confirm"
                secondaryButtonText="scaDisclaimer-cancel"
                type="filter"
            />
        </div>
    );
};


ScaDisclaimerModal.propTypes = {
    getTitleAndDescription: PropTypes.func,
    onCloseCallback: PropTypes.func.isRequired,
    onPrimaryButtonClick: PropTypes.func.isRequired,
    phone: PropTypes.string.isRequired,
    showPN: PropTypes.bool,
    visible: PropTypes.bool.isRequired,
};

ScaDisclaimerModal.defaultProps = {
    showPN: false,
};

module.exports = ScaDisclaimerModal;
